<template>
    <div style="margin: 0px 5px 0px 5px" id="body">
        <!--头部-->
        <div style="display: flex;justify-content: space-between;margin-bottom: 12px">
            <div>
            <el-button type="primary"  @click="addLine()"  :disabled="disabled" size="mini">编辑</el-button>
            </div>
            <div style="display: flex">
<!--                <el-select style="width: 30%;" clearable size="mini" v-model="select" slot="prepend" placeholder="请选择">-->
<!--                    <el-option v-for="val in paiban" :key="val.i_ispb" :label='val.vc_ispb' :value="val.i_ispb"></el-option>-->
<!--                </el-select>-->
                <el-select @change="fangansearch" clearable style="width: 120px;" size="mini" v-model="fangan" slot="prepend" placeholder="请选择方案">
                    <el-option v-for="(val,index) in fanganliebiao" :key="index" :label="val.vc_tcname" :value="val.vc_djmark"></el-option>
                </el-select>
                <el-select @change="gangweisearch" clearable style="width: 120px" size="mini" v-model="gangwei" slot="prepend" placeholder="请选择岗位">
                    <el-option v-for="val in postData" :key="val.id" :label='val.name' :value="val.id"></el-option>
                </el-select>
                <el-select @change="paibansearch" clearable style="width: 120px" size="mini" v-model="paibanshuju" slot="prepend" placeholder="请选择排班">
                    <el-option v-for="val in paiban" :key="val.i_ispb" :label='val.vc_ispb' :value="val.i_ispb"></el-option>
                </el-select>
                <el-input

                        size="mini"
                        style="width: 300px;"
                        placeholder="ID/姓名/所属部门"
                        v-model="input"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>
        </div>
            <el-table
                    size="mini"
                    stripe
                    @selection-change="selectval"
                    ref="deliverlight"
                    class="table"
                    :height="tableHeight"
                    highlight-current-row
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}">
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        :label="$t('form_serial_number')"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="i_id"
                        label="ID"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="vc_name"
                        label="姓名"
                        show-overflow-tooltip>
<!--                    <template slot-scope="scope">-->
<!--                        <el-select v-model="scope.row.name"   placeholder="请选择人员" @change="changename(scope.row)"  size="mini">-->
<!--                            <el-option-->
<!--                                    v-for="item in persdata"-->
<!--                                    :key="item.i_id"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.i_id">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column width="150" prop="vc_gsname" label="所属公司"></el-table-column>
                <el-table-column
                        width="150"
                        prop="vc_dept"
                        label="所属部门"
                        >
                </el-table-column>
                <el-table-column
                        prop="vc_kqtc"
                        label="考勤方案"
                >
                </el-table-column>
                <el-table-column
                        prop="vc_position"
                        label="岗位"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="vc_ispb"
                        label="排班"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_bc"
                        label="班次"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column

                        label="是否弹性"
                >
                                        <template slot-scope="scope">
                                <span>{{scope.row.elastic==0?'否':'是'}}</span>
                                        </template>
                </el-table-column>
                <el-table-column label="考勤开始时间" prop="dt_kqstarttime">
                </el-table-column>
                <el-table-column label="考勤结束时间"prop="dt_kqendtime">
                </el-table-column>
                <el-table-column
                        prop="dt_edittime"
                        label="最后编辑时间"
                        show-overflow-tooltip>
                </el-table-column>

            </el-table>
<!--        </el-form>-->

        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="total"
                            :total="tableTotal"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            class="fr page"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next, jumper"
                            :total="tableTotal">
                    </el-pagination>
                </div>

            </div>
        </div>
        <!--交付dialog-->
        <div>
            <el-dialog
                    :close-on-click-modal="false"

                    :class="baseerp+'div'"
                    width="700px"
                    title="考勤人员设置"
                    :visible.sync="paymentdialogVisible"
                    @close="cancelRenderDialog"
                    v-if="paymentdialogVisible">
                <add-attend :paiban="paiban" @baocun="baocun" @getList="getList" :tableData="tableData" :formvalue="formvalue" :bianjishuzu="bianjishuzu"  @close="cancelRenderDialog"></add-attend>
                <!--                <render-form :render="render" @close="cancelRenderDialog" @getOutputList="getOutputList" ></render-form>-->
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import addAttend from "./component/AddAttend";
    export default {
        name: "AttendancePers",
        components: {
            addAttend
        },
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                gangwei:'',
                paibanshuju:'',
                paiban:[{
                    i_ispb:0,
                    vc_ispb:"固定班",
                },{
                    i_ispb:1,
                    vc_ispb:"排班",
                }
                ],
                fangan:'',
                paymentdialogVisible:false,
                mentdialogVisible:false,
                disabled:false,
                baseerp:"",
                pageSize:10,
                select:-1,
                input:'',
                currentPage:1,
                tableTotal:4,
                mid:0,
                tableHeight:0,
                tableData:[],
                i_id:0,
                bianjishuzu:[],
                fanganliebiao:'',
                postData:'',
                select1:'',
                select2:'',
                //index: 0,
            }
        },

        watch:{
            formvalue:{
                handler(){
                    if (this.formvalue){
                        // console.log(1111)
                        // console.log(this.formvalue,11);
                        this.i_id=this.formvalue.i_id;
                        this.getList()
                        //this.formData.i_id=this.formvalue.i_id;
                        // this.formData.vc_tcname=this.formvalue.vc_tcname;
                        // this.formData.vc_djmark=this.formvalue.vc_djmark;
                        // this.formData.i_start=this.formvalue.i_start;
                        // this.formData.i_end=this.formvalue.i_end;
                        // this.formData.vc_lruname=this.formvalue.vc_createuser;
                        // this.formData.date=this.formvalue.dt_createtime;
                        if (this.i_id!=0){
                            this.edit = true;
                        }else{
                            this.edit = false;
                            // this.newData();
                        }
                    }
                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },


        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.select1=-1
            this.select2=0
            this.positionlist()
            this.kaoqinfangan()
            this.baseerp=baseerp;
            // this.$nextTick(function () {
            //     window.addEventListener('resize',this.heightAuto);
            //     this.heightAuto();
            // });
            this.$nextTick(()=>{
                this.onResize();

            })
            this.getList()
            // this.positionlist()
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-130
            },
            //获取岗位列表

            async positionlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };


                let param={
                    i_uid:sessionStorage.getItem("userid")
                }
                let res=await API.positionlist(param)
                if(res.code==1){
                    this.postData=res.data
                    // this.jobhour=val[0]+val[1]
                    // console.log(res.data,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            ...mapActions(["getCurrentMenuId"]),
            fangansearch(val){
                // if(val==''){
                //     this.fangan=''
                // }else {
                //     let add=this.fanganliebiao.filter(item=>{
                //         return item.i_id==val
                //     })
                //     this.fangan=add[0].vc_djmark
                //     // this.bcid=''
                // }

                // console.log(this.fangan)
                // this.input=this.fangan
                this.currentPage=1
                this.getList()
            },
            paibansearch(val){
                // console.log(this.paibanshuju)
                if(val==''&&val!==0){
                    this.select1=-1
                    // console.log(999)
                    // this.paibanshuju=-1
                }else{
                    this.select1=val
                }

                // this.input=th
                this.currentPage=1
                this.getList()
            },
            gangweisearch(val){
                // console.log(this.gangwei)
                if(val==''){
                    this.select2=0
                }else{
                    this.select2=val
                }
                // this.input=this.
                this.currentPage=1
                this.getList()
            },
            Search(){
                // if(this.input==''){
                //     this.$message({
                //         message: '请输入ID值',
                //         type: 'warning'
                //     });
                // }
                // console.log(this.select)
                this.getList()
                this.currentPage=1
            },
            //考勤方案列表
            async kaoqinfangan(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_mid: this.mid,
                }
                let res=await API.getKqList(param)
                if(res.code==1){
                    this.fanganliebiao=res.data
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            baocun(){
                this.paymentdialogVisible=false
            },

            async getList(){
                // console.log(78777)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    i_id:this.i_id,
                    page_size:this.currentPage,
                    page_count:this.pageSize,
                    vc_search:this.input,
                    i_ispb:this.select1,
                    i_position:this.select2,
                    vc_djmark:this.fangan,

                }
                let res=await API.getKqRyList(param)
                if(res.code==1){
                    this.tableData=res.data
                    this.tableTotal=res.count
// val=2
//                     console.log(val)
                    // console.log(res.data)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            cancelRenderDialog(){
                this.paymentdialogVisible=false
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getList()
            },

            heightAuto(){
                this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -90;
            },

            edit(row){
                // console.log("rowedit",row);
            },



            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
            },
            selectval(selection){
                this.bianjishuzu=selection
                // console.log(selection)
                // console.log(this.bianjishuzu)
            },

            // 增加一个空行, 用于录入或显示第一行
            addLine() {
                // //console.log(this.bianjishuzu.length)
                if(this.bianjishuzu.length==0){
                    this.$message.error('请选择要编辑的人员信息')
                }else {
                    this.paymentdialogVisible=true
                }
            },

            // 提交
            submit() {
                this.disabled=false;
            }

        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 28px;
            width: 46px;
            margin:12px 0 0 10px;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }

    /*.mrt20{*/
    /*    !*margin-top: 20px;*!*/
    /*}*/
    .mrl20{
        margin-left: 20px;
    }
    .mrb20{
        margin-right: 20px;
    }
    .mrr20{
        /*margin-right: 20px;*/
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        width:90%
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    /*.mrt20{*/
    /*    !*margin-top: 8px;*!*/
    /*}*/

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }


    }

    .all {
        width: 100%;
    }
    .flex-c-a {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .margin-top-10 {
        margin-top: 10px;
    }
    .base-form.el-form-item__content {
        margin-left: 0;
    }
    .add-btn {
        color: #4077F4;
    }
    .delete-btn {
        color: #f56c6c;
    }


</style>